import { useState, useEffect } from "react";
import { FaEnvelope } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";

const NAV_LINKS = [
  { label: "Training", to: "/" },
  { label: "Services", section: "services" },
  { label: "Courses", section: "courses" },
  { label: "Careers", section: "rolemap" },
  { label: "Labs", section: "labs" },
  { label: "FAQs", section: "faq" },
  { label: "Enroll", section: "enroll" },
  { label: "About", to: "/services/#about" },
  { label: "Contact", to: "/services/#contact" },
];

export default function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const scrollToSection = (sectionId) => {
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        const navbarHeight = 120;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: elementPosition - navbarHeight, behavior: "smooth" });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }
    setMobileOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="w-full bg-white text-black text-sm py-2 px-4 flex justify-end items-center">
        <span className="flex items-center gap-1">
          <FaEnvelope className="text-red-500" /> contact@hackdefense.org
        </span>
      </div>
      <nav className="bg-black/90 backdrop-blur-md border-b border-[#27272a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img src={logo} alt="Hack Defense Logo" className="h-8 w-auto md:h-10" />
            </Link>

            {/* Desktop nav */}
            <div className="hidden lg:flex items-center gap-1">
              {NAV_LINKS.map((link) =>
                link.to ? (
                  <Link
                    key={link.label}
                    to={link.to}
                    className={`text-sm font-medium px-3 py-2 rounded-md transition-colors duration-300 ${isActive(link.to) ? "text-white" : "text-gray-400 hover:text-white"}`}
                  >
                    {link.label}
                  </Link>
                ) : (
                  <button
                    key={link.label}
                    onClick={() => scrollToSection(link.section)}
                    className="text-sm font-medium text-gray-400 hover:text-white px-3 py-2 rounded-md transition-colors duration-300"
                  >
                    {link.label}
                  </button>
                )
              )}
            </div>

            <div className="hidden lg:block">
              <Link
                to="/#enroll"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("enroll");
                }}
                className="bg-white text-black px-4 py-2 rounded-md text-sm font-semibold hover:bg-gray-200 transition-colors"
              >
                Enroll now
              </Link>
            </div>

            {/* Mobile hamburger */}
            <div className="lg:hidden">
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-white"
              >
                <span className="sr-only">Open main menu</span>
                {!mobileOpen ? (
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M3 12h18M3 6h18M3 18h18" />
                  </svg>
                ) : (
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M6 18L18 6M6 6l12 12" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="lg:hidden border-t border-[#27272a]">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {NAV_LINKS.map((link) =>
                link.to ? (
                  <Link
                    key={link.label}
                    to={link.to}
                    onClick={() => setMobileOpen(false)}
                    className={`block px-3 py-2 rounded-md text-base font-medium ${isActive(link.to) ? "text-white" : "text-gray-300 hover:text-white"}`}
                  >
                    {link.label}
                  </Link>
                ) : (
                  <button
                    key={link.label}
                    onClick={() => scrollToSection(link.section)}
                    className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium w-full text-left"
                  >
                    {link.label}
                  </button>
                )
              )}
              <Link
                to="/#enroll"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("enroll");
                }}
                className="block px-3 py-2 rounded-md text-base font-medium bg-white text-black text-center mt-2"
              >
                Enroll now
              </Link>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
}
